import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import './assets/theme.scss';

import fetch from './fetch';
import axios from "axios";

Vue.prototype.$http = fetch
Vue.config.productionTip = false
Vue.use(ElementUI);

Vue.prototype.$supplierList = [{
  label: 'TI',
  value: 'TI'
}]
Vue.prototype.$supplier = 'TI'

axios.defaults.withCredentials = true

router.beforeEach((to, from, next) => {

  if (to.path === "/login") {
    next();
    return;
  }
  axios.get('/check-login')
      .then(res => {
        const isLoggedIn = res.data.data;
        if (isLoggedIn) {
          next();
        } else {
          next("/login")
        }
      })
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
